import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import Header from "./Header/Header";
import LeftSidebar from "./LeftSidebar/LeftSidebar";
import MainContent from "./MainContent/MainContent";

import { ActionsDataViz } from "../../../Actions/ActionsDataViz/ActionsDataViz";

import * as SC from "./DataVisualization.styled";
import "./DataVisualization.styles.css";

import { withRefluxStore } from "../../../Stores";
import DataVizStore from "../../../Stores/DataVizStore";

const DataVisualization = ({ channelCampaigns, match, campaignData }) => {
  const { params = "" } = match;
  const [selectedAdsetId, setSelectedAdsetId] = useState(null);

  // Get data for new layout
  useEffect(() => {
    ActionsDataViz.loadDataVizCampaignData(params.id);
  }, [params]);

  // Get metricsToUse for new layout
  useEffect(() => {
    ActionsDataViz.setMetricsToUse(channelCampaigns, selectedAdsetId);
  }, [channelCampaigns, selectedAdsetId]);

  return (
    <SC.ContentContainer>
      <Header />
      <SC.MainArea>
        <LeftSidebar />
        <SC.MainBody>
          <MainContent campaignData={campaignData} />
        </SC.MainBody>
      </SC.MainArea>
    </SC.ContentContainer>
  );
};

export default withRouter(
  withRefluxStore(DataVisualization, [DataVizStore], ["channelCampaigns", "campaignData"])
);
